<template>
  <el-dialog :visible="visible" title="选择店铺" width="800px" @close="close">
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleAllChange">全选</el-checkbox>
    <div style="margin: 15px 0"></div>
    <el-checkbox-group v-model="shopIds" @change="handleChange">
      <el-checkbox v-for="s in data" :label="s.id" :key="s.id">{{ s.shortTitle || s.title }}</el-checkbox>
    </el-checkbox-group>
    <template slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button @click="ok" type="primary">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'shop-dialog',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      checkAll: false,
      shopIds: [],
      isIndeterminate: true,
      opts: {}
    };
  },
  methods: {
    handleAllChange(val) {
      this.shopIds = val ? this.data.map(s => s.id) : [];
      this.isIndeterminate = false;
    },
    handleChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.data.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.data.length;
    },
    method_open(opts){
      this.opts = opts;
      this.visible = true
    },
    close() {
      this.visible = false
      this.shopIds = [];
    },
    ok() {
      if (!this.shopIds.length) return this.$message.warning('请选择一个店铺');
      this.opts.okFn && this.opts.okFn(this.shopIds)
      this.close();
    },
  },
};
</script>
